export default __webpack_public_path__ + "static/media/PROCESSMETHOD_SHEETMETAL_PRESS.655f932f.png";